"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SERT_KURAL_ETIKETI = exports.SOZLUK_LISTE_ENVANTERI = void 0;
exports.sozlukEklenebilirMi = sozlukEklenebilirMi;
exports.sertKuralIhlalleri = sertKuralIhlalleri;
const saglik_1 = require("./saglik");
const egitim_1 = require("./egitim");
const gorevlendirme_1 = require("./gorevlendirme");
const contractor_1 = require("./contractor");
const K = (modul, editor = null, digerKuyrugu = false) => ({ sinif: 'kutuphane', modul, editor, eklemeSarti: null, digerKuyrugu });
exports.SOZLUK_LISTE_ENVANTERI = {
    // ── Çalışan / yetkinlik ──
    yetkinlik_tipi: K('calisan', 'sure_sinifi'),
    yetki_tipi: {
        sinif: 'musteri',
        modul: 'calisan',
        editor: null,
        eklemeSarti: null,
        digerKuyrugu: false,
    },
    gorevlendirme_turu: K('calisan', 'gorevlendirme'),
    // ── Ekipman ──
    equipment_tip: K('ekipman', 'uyari_esigi'),
    kapasite_birimi: K('ekipman'),
    // ── Yüklenici ──
    // ✏️ TUR 6 / Ş6 (S11): 5½ envanteri `musteri` yazmıştı; §19/12-c'de 12
    // kalem ✅ duruyordu. Liste KÜTÜPHANEDİR (`YUKLENICI_EVRAK_KUTUPHANESI` — 10
    // kalem, ürün sahibinin süreç listesine hizalı) ve kural ekseni listeyle
    // doğdu: eksen · vade_takibi · zorunlu · saglik · uyari_esigi_gun.
    evrak_tipi: K('yuklenici', 'evrak'),
    // ── Olay ──
    olay_turu: K('olay'),
    olay_sinifi: {
        sinif: 'karisik',
        modul: 'olay',
        editor: null,
        eklemeSarti: 'ana_kalem',
        digerKuyrugu: true,
    },
    // Merdiven ÜRÜN KİLİTLİ — incident kolonları `sira` taşır; sözlük yalnız gösterim.
    olay_siddeti: {
        sinif: 'sabit',
        modul: 'olay',
        editor: null,
        eklemeSarti: null,
        digerKuyrugu: false,
    },
    mekanizma: K('olay', null, true),
    // Ölçek (sıra 1-5) — seviye türetmesiyle birebir; kademe eklemek ölçeği bozar.
    yayilim_siniri: {
        sinif: 'sabit',
        modul: 'olay',
        editor: null,
        eklemeSarti: null,
        digerKuyrugu: false,
    },
    madde_tehlike_sinifi: K('olay', null, true),
    kok_sebep_grubu: K('olay'),
    kok_sebep: {
        sinif: 'karisik',
        modul: 'olay',
        editor: null,
        eklemeSarti: 'grup',
        digerKuyrugu: true,
    },
    // Üç kalemle KAPALI — "Diğer" bilinçli yok (R7 tutanağı).
    olay_red_gerekcesi: {
        sinif: 'sabit',
        modul: 'olay',
        editor: null,
        eklemeSarti: null,
        digerKuyrugu: false,
    },
    // T2·0'da SÖKÜLDÜ — nüsha gizli; ölü liste, ekran çizmez.
    olay_kapanis_gerekcesi: {
        sinif: 'sabit',
        modul: 'olay',
        editor: null,
        eklemeSarti: null,
        digerKuyrugu: false,
    },
    olay_aydinlatma: K('olay'),
    olay_zemin: K('olay'),
    yaralanma_turu: K('olay'),
    vucut_bolgesi: K('olay'),
    // ── Aksiyon ──
    aksiyon_kaynagi: K('aksiyon'),
    // ── İzin ──
    izin_turu: K('izin'),
    izin_gorevi: K('izin'),
    geri_cekilme_gerekcesi: K('izin'),
    // ── Eğitim ──
    egitim_turu: K('egitim', 'sure_sinifi'),
    egitim_konusu: K('egitim', 'bakanlik_kodu'),
    egitim_yeri: {
        sinif: 'musteri',
        modul: 'egitim',
        editor: 'bakanlik_kodu',
        eklemeSarti: null,
        digerKuyrugu: false,
    },
    sertifika_tipi: {
        sinif: 'musteri',
        modul: 'egitim',
        editor: 'bakanlik_kodu',
        eklemeSarti: null,
        digerKuyrugu: false,
    },
    egitim_yontemi_ibys: {
        sinif: 'musteri',
        modul: 'egitim',
        editor: 'bakanlik_kodu',
        eklemeSarti: null,
        digerKuyrugu: false,
    },
    // ── Sağlık ──
    muayene_turu: K('saglik', 'muayene'),
    uygunluk_karari: {
        sinif: 'karisik',
        modul: 'saglik',
        editor: null,
        eklemeSarti: 'ana_kalem',
        digerKuyrugu: false,
    },
    saglik_kisiti: K('saglik'),
    // ── Risk ──
    risk_tehlike: K('risk', null, true),
    risk_riski: K('risk', null, true),
    // ── Saha turu / denetim (05.09.2026 — Kapsam §27/S8) ──
    // DENETLENEN BİRİM: organizasyonel eksen (lokasyon ağacı fizikseldir).
    // MÜŞTERİ sınıfı — kütüphane başlangıcı VERİLMEZ, içerik müşteriye ait;
    // kural editörü yok (yalnız ekle/gizle). Beşinci müşteri listesi.
    denetlenen_birim: {
        sinif: 'musteri',
        modul: 'saha_turu',
        editor: null,
        eklemeSarti: null,
        digerKuyrugu: false,
    },
    // ── KKD zimmeti (07.09.2026 — Kapsam §30/Z2) ──
    // KKD KALEMİ: 07.09'da MÜŞTERİ sınıfı + kütüphane BOŞ doğdu (içerik
    // uydurulmadı — ERD §12/61). ✏️ 08.09.2026 (içerik kararları paketi —
    // madde 210 KAPANDI, bir gün açık kaldı): ürün sahibinin 22 kalemlik listesi
    // geldi → KÜTÜPHANE sınıfı (tur 6 `evrak_tipi` emsali; `@isg/db
    // KKD_KALEMI_KUTUPHANESI`). Kural editörü yok (ömür kuralı v2 — Z4).
    kkd_kalemi: K('kkd'),
};
/** Ekleme yüzeyi açılan listeler — `sabit` dışındakiler. */
function sozlukEklenebilirMi(listeKodu) {
    return exports.SOZLUK_LISTE_ENVANTERI[listeKodu].sinif !== 'sabit';
}
/**
 * SERT KURALLAR — TEK YÜKLEM (Kapsam §19/7 sınır paragrafı, 5½ eki).
 *
 * *"Müşteri sıkılaştırabilir, gevşetemez"* ilkesinin kod karşılığı burada
 * toplanır; sözlük yazma ucu (`POST/PATCH lookup`) **bunu** çağırır, ekran
 * hangi listenin sert kural taşıdığını **bundan** okur (rozet). Liste
 * §19/7'nin listesidir — buraya kalem eklemek ürün kararıdır:
 *
 *   yetkinlik_tipi · egitim_turu → süre sınıfı guard'ı (K6)
 *   muayene_turu                 → muayene periyodu TAVANI (S2 — artık
 *                                  yazma anında da)
 *   gorevlendirme_turu           → zorunlu sayı TABANI (B3; kütüphane
 *                                  nüshasında)
 *
 * Dönüş: ihlal mesajları (D2 dili — JSON anahtarı yok). Boş dizi = geçer.
 */
function sertKuralIhlalleri(listeKodu, kutuphaneKurallar, yeniKurallar) {
    switch (listeKodu) {
        case 'yetkinlik_tipi':
        case 'egitim_turu':
            return (0, egitim_1.sureSinifiIhlalleri)(yeniKurallar);
        case 'muayene_turu':
            return (0, saglik_1.muayenePeriyotIhlalleri)(yeniKurallar);
        case 'evrak_tipi':
            // TUR 6 / Ş6: biçim denetimi — bozuk uyarı eşiği sessizce 30'a DÜŞMEZ
            // (eksen sözlüğü · üç bool · pozitif gün). Kütüphane tabanı yok.
            return (0, contractor_1.evrakTipiKuralIhlalleri)(yeniKurallar);
        case 'gorevlendirme_turu':
            // Taban yalnız KÜTÜPHANE nüshasında vardır; müşteri kaleminde
            // (`kutuphaneKurallar` null) her değer serbesttir (§19/7 — iddia eden yok).
            return kutuphaneKurallar === null || kutuphaneKurallar === undefined
                ? []
                : (0, gorevlendirme_1.zorunluSayiGevsetmeIhlalleri)((0, gorevlendirme_1.readZorunluSayi)(kutuphaneKurallar), (0, gorevlendirme_1.readZorunluSayi)(yeniKurallar));
        default:
            return [];
    }
}
/** Ekranın rozeti: bu liste sert (mevzuat sınırlı) kural taşıyor mu ve hangisini? */
exports.SERT_KURAL_ETIKETI = {
    yetkinlik_tipi: 'Belge sınıfına periyot yazılamaz',
    egitim_turu: 'Belge sınıfına periyot yazılamaz',
    muayene_turu: 'Muayene periyodu mevzuat tavanını aşamaz',
    gorevlendirme_turu: 'Zorunlu sayı kütüphane değerinin altına inemez',
    evrak_tipi: 'Evrak kuralı biçim denetimlidir (eksen · vade · zorunlu · sağlık · eşik)',
};
//# sourceMappingURL=sozluk.js.map